<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="handleAdd1">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" type="danger" :disabled="multiple"
            v-preventReClick @click="handleDelete">删除</el-button>

          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
      </div>
      </div>

      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
        <template slot="after">
          <template slot="before">
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
          </template>
          <el-table-column fixed="right" prop="operation" label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="text" v-preventReClick @click="handleInfo1(scope.row)" class="color-blue">查看详情</el-button>
              <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick
                @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
            </template>
          </el-table-column>
        </template>
        </CustomTable>
    </div>
    <div v-else>
      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight"
      style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
      <template slot="empty">
        <div class="empty-div" :style="{ height: tableHeight + 'px' }">
          <img src="../../../../assets/noData.png" width="240" height="240" />
          <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
          <div class="empty-rest" @click="reset">恢复默认</div>
        </div>
      </template>
      <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
      </el-table-column>
      <el-table-column prop="warehouseName" label="库房"></el-table-column>
      <el-table-column width="120" prop="startDate" label="开始日期">
        <template slot-scope="scope">{{
          parseTime(new Date(scope.row.startDate), "{y}-{m}-{d}")
          }}</template>
      </el-table-column>
      <el-table-column width="120" prop="endDate" label="结束日期">
        <template slot-scope="scope">{{
          parseTime(new Date(scope.row.endDate), "{y}-{m}-{d}")
          }}</template>
      </el-table-column>
      <el-table-column prop="createdUserName" label="创建人"></el-table-column>
      <el-table-column width="170" prop="createdTime" label="创建时间">
        <template slot-scope="scope">
          {{
            parseTime(
              new Date(scope.row.createdTime),
              "{y}-{m}-{d} {h}:{i}:{s}"
            )
          }}
        </template>
      </el-table-column>

      <el-table-column fixed="right" prop="operation" label="操作" width="180">
        <template slot-scope="scope">
          <el-button type="text" v-preventReClick @click="handleInfo1(scope.row)" class="color-blue">查看详情</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick
            @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>
   
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>

    <el-dialog :title="title + route.menuName" :visible.sync="open" :center="true" width="1100px" :before-close="cancel"
      :close-on-click-modal="false">
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="库房" prop="warehouseId">
              <el-select style="width: 100%" :disabled="!editMode" v-model="form.warehouseId" filterable
                :filter-method="getWarehousesBySessionWarehouseId" placeholder="请选择仓库" @change="warehouseChange">
                <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开始时间" prop="startDate">
              <el-date-picker style="width: 100%" :disabled="!editMode" v-model="form.startDate" size="small"
                type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间" prop="endDate">
              <el-date-picker style="width: 100%" :disabled="!editMode" v-model="form.endDate" size="small" type="date"
                :picker-options="pickerTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
        <my-button v-if="editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="submit">确
          定</my-button>
      </div>
    </el-dialog>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import {
  GetStockBalanceLog,
  GetBalanceStartDate,
  CreateStockBalance,
  RemoveStockBalance,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
// import { StockCategoryOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data() {
    return {
      GetDatasAction: GetStockBalanceLog,
      RemoveAction: RemoveStockBalance,
      // PrintAction: GetPrintData,
      // editPath: 'apply-out-stock-edit',

      // StockCategoryOptions: StockCategoryOptions,
      filterOptions: [
        {
          name: "库房",
          type: "select",
          code: "warehouseId",
          filterMethod: this.getWarehouses,
          data: [],
        },
      ],
      pickerTime: {
        disabledDate: (time) => {
          // 结束时间只能选择今天以前的时间
          return time.getTime() > new Date().getTime() - 1000 * 60 * 60 * 24;
        },
      },
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 新增、编辑的数据
      form: {},
      editMode: false,
      rules: {
        warehouseId: [
          { required: true, message: "请选择库房", trigger: "blur" },
        ],
        startDate: [
          { required: true, message: "请选择开始时间", trigger: "blur" },
        ],
        endDate: [
          { required: true, message: "请选择结束时间", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 新建
    handleAdd1() {
      this.open = true;
      this.title = "新建";
      this.resetForm();
      this.editMode = true;
      this.getWarehousesBySessionWarehouseId("");
    },
    // 编辑
    handleInfo1(row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.title = "查看";
      this.editMode = false;
    },
    // 保存
    submit() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        CreateStockBalance(this.form)
          .then((res) => {
            this.open = false;
            this.$my_message(`执行成功`, "success");
            this.getData();
          })
          .finally(() => {
            this.$store.dispatch("SetLoading", false);
          });
      });
    },
    resetForm() {
      this.form = {
        id: 0,
        warehouseId: "",
        startDate: "",
        endDate: "",
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
    // 取消编辑
    cancel() {
      this.$store.dispatch("SetLoading", false);
      if (this.editMode) {
        this.$my_confirm("确认要中断当前操作吗？", "提示", {
          type: "warning",
        })
          .then(() => {
            this.open = false;
          })
          .catch(() => { });
      } else {
        this.open = false;
      }
    },
    warehouseChange(val) {
      if (!val) {
        this.form.startDate = "";
      }

      GetBalanceStartDate({ warehouseId: val }).then((res) => {
        this.form.startDate = res.returnData;
      });
    },
  },
  mounted() { },
};
</script>

<style lang="scss" scoped></style>
